import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';

const ContactForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
console.table(form.current.reply_to)
    emailjs.sendForm('service_yb740q3', 'template_1r1f35a', form.current, {
        publicKey: 'DAwBmAa9R4OjrDBoy',
      })
      .then(
        () => {
          alert('Email sent successfully!');
          // Optional: reload the page or reset the form
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Failed to send email.');
        }
      );
  };

  return (
    
    <form ref={form} onSubmit={sendEmail} className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"center",background:'#eceff3f6',width:"auto", justifyContent:"center"}}>
      <br></br>
      <br></br>
      <div className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"left",background:'#eceff3f6'}}>
        We would love to hear back from you with any questions or comments you may have.<br></br>
        Please use the form below to send a note, ask us a question or make a comment.<br></br>
        We do appreciate your feedback!
      </div>
      <br></br>
      <br></br>
      <label>
        Please select the contact topic:
        <br></br>
        <select name="topic" required="true" className={`blackBodyFontCenterBold`}>
          <option value="Request to be Event Guest">Request to attend event as Guest Couple</option>
          <option value="Request more Event Info">Request more information regarding our events</option>
          <option value="Request more Membership Info">Request more information on how to become a Member Couple</option>
          <option value="Other question">Other comment/question about Kermis Dance Club</option>
        </select>
      </label>
      <br></br>
      <label>Please provide a short description of your request:
      <input className={`blackBodyFontCenterBold`} type="text" name="title" style={{width:"90%",alignItems:"center"}}/>
      </label>
      <br></br>
      <label>Please provide your name:
      <input className={`blackBodyFontCenterBold`} type="text" name="name" required="true" style={{width:"90%",alignItems:"center"}}/>
      </label>
      <br></br>
      <label>Please provide the best method to contact you (email address or phone number)
      <input id="email" className={`blackBodyFontCenterBold`} type="text" name="reply_to" required="true" style={{width:"90%",alignItems:"center"}}/>
      </label>
      <br></br>
      <label>Message
        <br></br>
      <textarea className={`blackBodyFontCenterBold`} name="message" required="true" rows="10" style={{width:"90%",alignItems:"center"}} />
      </label>
      <br></br>
      <div style={{alignItems:"center"}} >
      <input className={`blackBodyFontCenter`} type="submit" value="Send"  style={{width:"20%",alignItems:"center",background:'#bbc1c9'}} />
      </div>
    </form>
  );
};
export default ContactForm;